import * as SelectPrimitive from '@radix-ui/react-select';

export const PvSelectValue = SelectPrimitive.Value;
